<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        icon="mdi-infinity"
        :breadcrumbs="breadcrumbs"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mb-5">
        <v-col class="text-right" cols="12">
          <v-btn
              color="primary"
              @click="add"
          >
            Thêm
          </v-btn>
        </v-col>
      </v-row>
      <v-row align="center" class="mt-n6 " justify="center">
        <v-col cols="12">
          <v-data-table
              :headers="headers"
              :items="process"
              :items-per-page="10"
              class="elevation-1">
            <template v-slot:item.description="{ item }">
              <span v-html="item.description"></span>
            </template>
            <template v-slot:item.active="{ item }">
              <v-switch
                  v-model="item.active"
                  class="pa-3"
                  :value="item.active"
                  @click="updateActive(item.id)"
              ></v-switch>
            </template>
            <template v-slot:item.actions="{ item }">
              <v-icon class="mr-2" small @click="editItem(item.id)">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item.id)"> mdi-delete</v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {DELETE_PROCESS, GET_DETAIL_PROCESS, GET_LIST_PROCESS, UPDATE_PROCESS} from "@/store/modules/process";

export default {
  name: "Process",
  data(){
    return{
      page: "Danh sách Process",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Danh sách Process",
          disabled: false,
        },
      ],
      headers: [
        {
          text: 'Arrangement',
          align: 'start',
          value: 'arrangement',
        },
        {text: 'Name', value: 'name'},
        {text: 'Description', value: 'description'},
        {text: 'Hiển thị', value: 'active'},
        {text: 'Actions', value: 'actions', sortable: false},
      ],
      url: '',
      selected: -1,

    }
  },
  computed:{
    ...mapGetters({
      process:"process",
      processDetail:"processDetail"
    })
  },
  async created() {
    await this.$store.dispatch(GET_LIST_PROCESS);
  },
  methods:{
    async updateActive(id) {
      await this.$store.dispatch(GET_DETAIL_PROCESS, id)
      this.process.forEach(item => {
        if (item.id == id) {
          this.selected = item.active == true ? 1 : 0
        }
      })
      this.processDetail.active = this.selected
      await this.$store.dispatch(`${UPDATE_PROCESS}`, this.processDetail).then((data) => {
        if (data.data.status == 1) {
          this.$toasted.success('Cập nhật thành công!', {
            duration: 1000,
            position: 'top-center'
          })
          this.$router.push('/process')
        } else {
          alert(data.data.errors)
        }
      });
    },
    deleteItem(id) {
      confirm('Bạn có chắc chắn muốn xóa không ?') &&
      this.$store.dispatch(`${DELETE_PROCESS}`, id).then(data => {
        if (data && data.status === 1) {
          this.$store.dispatch(GET_LIST_PROCESS);
        }
      })
    },
    editItem(id) {
      this.$router.push({
        path: "/process/edit_process/" + id,
      });
    },
    add(){
      this.$router.push('/process/add_process')
    }
  }
}
</script>

<style scoped>

</style>